import Cookie from 'components/cookie';
import CustomSelect from 'components/form/custom-select';
import Form from 'components/form';
import Observer from './observer';
import PopupFacade from 'components/popup/popupFacade';
import ScrollBy from 'components/scrollBy';
import Tabs from 'components/tabs';
import {Utils} from './utils';
import Validation from 'components/form/validation';

const validation = new Validation();
const observer = new Observer();

// Инициализация попапов
export const initPopup = (buttons, otherOptions = {}) => {
    const options = {
        ...{openButtons: buttons},
        ...otherOptions
    };

    new PopupFacade(options).init();
};

// Инициализация форм
export const initForm = (wrapper) => {
    new Form().init({
        target        : wrapper,
        successMessage: true
    });
};

// Инициализация формы обратной связи в попапах
export const initCallbackForm = () => {
    observer.subscribe('popup:open', (popup) => {
        if (!popup.content) {
            return;
        }

        // Форма
        const callbackSelector = popup.content.querySelector('.j-form');

        if (callbackSelector) {
            validation.refresh(callbackSelector);

            new Form().init({
                target        : callbackSelector,
                successMessage: true
            });
        }
    });
};

// Инициализация попапов с формой обратной связи
export const initCallbackPopup = (buttons, modify = 'popup_theme_callback') => {
    const options = {
        removeDelay         : 300,
        closeButtonAriaLabel: 'Закрыть форму обратного звонка',
        modify
    };

    // initCallbackForm();
    initPopup(buttons, options);
};


// Инициализация форм подписки
export const initSubscribePopup = (buttons, otherOptions = {}) => {
    const options = {
        ...{openButtons: buttons},
        ...otherOptions
    };

    // initCallbackForm();
    initPopup(buttons, options);
};

/* Подключение ленивой загрузки (img/picture/iframe) */
export const lazyLoadElements = (lazyElements) => {
    const replaceSource = (element) => {
        if (element.parentElement.tagName === 'PICTURE' && element.tagName === 'IMG') {
            element.addEventListener('load', () => {
                element.parentElement.style.backgroundImage = '';
            });
        }

        const targetAttribute = element.nodeName === 'SOURCE' ? 'srcset' : 'src';
        const sourceElement = element.nodeName === 'SOURCE' ? 'data-srcset' : 'data-src';

        element.setAttribute(targetAttribute, element.getAttribute(sourceElement));
        element.removeAttribute(sourceElement);
    };

    if ('IntersectionObserver' in window) {
        // Иначе по событию IntersectionObserver
        const lazyImageObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const lazyEl = entry.target;

                    replaceSource(lazyEl);
                    lazyImageObserver.unobserve(lazyEl);
                }
            });
        });

        lazyElements.forEach((lazyImage) => {
            if (Utils.isInViewport(lazyImage, -20)) {
                if (lazyImage.dataset.src) {
                    replaceSource(lazyImage);
                }
            } else {
                lazyImageObserver.observe(lazyImage);
            }
        });
    } else {
        // Если есть нативная поддержка атрибута или нет поддержки IntersectionObserver - подменяем сразу
        lazyElements.forEach((lazyEl) => {
            replaceSource(lazyEl);
        });
    }
};


// Якоря
export const initScrollBy = (options) => {
    const scrollBy = new ScrollBy(options);
    const activeClass = 'is-active';

    scrollBy.init();

    observer.subscribe('anchorChangeSection', (id) => {
        options.anchors.forEach((item) => {
            const href = item.getAttribute('href');

            item.classList.remove(activeClass);

            if (href === id || href === `/${id}`) {
                item.classList.add(activeClass);
            }
        });
    });
};

// Скролл наверх
export const initScrollToTop = (button) => {
    button.addEventListener('click', () => {
        window.scrollTo({
            top     : 0,
            behavior: 'smooth'
        });
        observer.publish('scrollToTop');
    });
};

// Блок о cookies
export const initCookie = (duration) => {
    new Cookie(duration).init();
};

// Селекты
export const initSingleSelect = (elem) => {
    new CustomSelect({container: elem}).init();
};

export const initMultiSelect = (elem) => {
    new CustomSelect({
        container: elem,
        template : 'radio'
    }).init();
};

// Табы
export const initTabs = (elemItem) => {
    new Tabs().init({elem: elemItem});
};
